<template>
  <v-main id="content">
    <v-container fluid fill-height>
      <v-row align="center" justify="center">
        <v-col xs="12" sm="8" md="2">
          <v-fade-transition>
            <v-card class="elevation-12 pa-3" v-show="!loading">
              <v-card-text>
                <div class="layout column align-center">
                  <!-- <img src="../assets/logo.svg" alt="Vue Material Admin" width="180" height="180"> -->
                  <h1 class="flex my-4 primary--text">DEFOR</h1>
                </div>
                <v-form v-model="isValid">
                  <v-text-field prepend-icon="mdi-account" name="login" label="Username" type="text" v-model="credentials.USUARIO" required :rules="rules"></v-text-field>
                  <v-text-field prepend-icon="mdi-lock" name="password" label="Password" type="password" v-model="credentials.PASSWORD" required :rules="rules" @keyup.enter="initLogin"></v-text-field>
                </v-form>
              </v-card-text>

              <v-card-actions class="justify-center">
                <v-btn color="primary" width="25%" :disabled="!isValid" @click="initLogin">Login</v-btn>
              </v-card-actions>
            </v-card>
          </v-fade-transition>
        </v-col>
      </v-row>
    </v-container>

    <span style="color: white; position: absolute; left: 10px; bottom: 0px;">v{{version}}</span>

    <v-snackbar :button="true" color="error" :bottom="true" :timeout="5000" :multi-line="true" v-model="showSnackBar">
      <v-icon>mdi-lock</v-icon>
      {{ errorMessage }}
    </v-snackbar>

    <v-overlay opacity="0.1" :value="loading">
      <v-progress-circular color="white" indeterminate size="100" width="5"></v-progress-circular>
    </v-overlay>
  </v-main>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import { version } from '../../package'

export default {
  name: 'Login',
  data: () => ({
    version: version,
    credentials: {},
    loading: false,
    isValid: false,
    rules: [
      v => !!v || 'Required field'
    ],
    showSnackBar: false,
    errorMessage: ''
  }),
  computed: {
    ...mapGetters('auth', [
      'accessToken'
    ])
  },
  methods: {
    ...mapActions('app', [
      'init'
    ]),
    ...mapActions('auth', [
      'login'
    ]),
    initLogin () {
      this.loading = true

      var self = this
      this.login(this.credentials).then(() => {
        self.init()
        self.$router.push('/')
      }).catch(() => {
        self.loading = false
        self.showError('An error has ocurred. Incorrect login.')
      })
    },
    showError (msg) {
      this.errorMessage = msg
      this.showSnackBar = true
    }
  },
  created () {
  },
  mounted () {
    let reason = this.$route.query.reason

    if (reason && reason === 'token_invalid') {
      this.showError('Your token has expired or is invalid. Please login again.')
    }
  }
}
</script>

<style scoped>
  #content {
    box-shadow: inset 0 0 0 1000px var(--v-primary-base);
    background-color: var(--v-primary-base);
  }
</style>
